export enum Statuses {
  ON_AIR = 'on-air',
  ON_BREAK = 'on-break',
  SICK = 'sick',
  ONLINE = 'online',
  OFFLINE = 'offline'
}
